module.exports = __webpack_public_path__ + "img/xqgl2.26b818c3.png";